module.exports = __webpack_public_path__ + "img/uuundulate_2.69672e26.svg";